import React from 'react';
import PropTypes from 'prop-types';

import './group-affiliation-promotion-id-me-button.scss';

function GroupAffiliationPromotionIdMeButton(props) {
  const { isAppliedPromotion, openVerificationWindow } = props;

  return (
    <>
      {!isAppliedPromotion && (
        <button onClick={openVerificationWindow}>
          <img
            alt="ID.me Logo"
            height="43"
            loading="lazy"
            src="/images/idme-button.svg"
            styleName="logo"
            width="218"
          />
        </button>
      )}
    </>
  );
}

GroupAffiliationPromotionIdMeButton.propTypes = {
  isAppliedPromotion: PropTypes.bool,
  openVerificationWindow: PropTypes.func
};

export default GroupAffiliationPromotionIdMeButton;
